<template>
  <div class="pe-box">
    <!-- <div
      class="canvas-area"
      v-if="isCanvasShow"
    >

    </div> -->
    <div class="demo-box">
      <div class="app-logo">
        <img :src="appLogo" />
      </div>
      <div class="search-box-title">
        在中日本人10万人をサポートするまるごとアプリ
      </div>
      <div class="search-box">
        <div class="search-input-area">
          Nanaco 中国
        </div>
        <div class="search-btn-area">
          <Icon type="ios-search" />
        </div>
      </div>
      <img
        class="app-icons"
        :style="'opacity:' + iconOpacity"
        :src="appIntroductionIcons"
      >
    </div>

  </div>
</template>
<script>
// import RENDERER from '../js/RENDERER'
import { appLogo, downloadImage, appIntroductionIcons } from '../../images/home/index'
export default {
  data () {
    return {
      boxPosition: '100',
      isCanvasShow: false,
      appLogo,
      downloadImage,
      appIntroductionIcons,
      isQrcodeShow: null,
      iconOpacity: 0
    }
  },
  methods: {
    init () {
      // this.isCanvasShow = true
      // this.$nextTick(() => {
      //   RENDERER.init(document.getElementsByClassName('canvas-area')[0])
      // })

    },
    setOpacity () {
      setTimeout(() => {
        this.iconOpacity = 1
      }, 500)
    },
    clearOpacity () {
      this.iconOpacity = 0
    }
  }
}
</script>
<style scoped>
.pe-box {
  height: 16.66%;
}
.demo-box {
  position: absolute;
  /* background: rgba(0, 0, 0, 0.5); */
  background-color: rgba(238, 242, 255, 1);
  background-image: url('../../images/home/app-down-bg.png');
  background-size: 100%;
  background-position: bottom;
  background-repeat: no-repeat;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 3rem;
}
.app-logo {
  margin: 0 auto;
  margin-top: 10%;
  width: 5rem;
  height: 5rem;
}
.app-logo img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.search-box-title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 1.1rem;
  padding: 0 2rem;
  font-weight: bold;
  color: rgba(7, 7, 7, 1);
  margin-top: 1.5rem;
  margin-bottom: 1.2rem;
  letter-spacing: 3px;
  text-align: center;
}
.search-box {
  height: 2.5rem;
  width: 80%;
  margin: 0 auto;
  border-radius: 60px;
  overflow: hidden;
  display: flex;
  box-shadow: 0px 0px 41px 0px rgba(129, 129, 129, 0.18);
  margin-bottom: 1.5rem;
}
.search-input-area {
  width: 80%;
  background: #fff;
  color: rgba(7, 7, 7, 1);
  box-sizing: border-box;
  padding-left: 10%;
  text-align: center;
  line-height: 2.5rem;
  font-size: 20px;
  font-weight: bold;
}
.search-btn-area {
  background-color: rgba(51, 51, 51, 1);
  text-align: center;
  color: rgba(255, 255, 255, 1);
  line-height: 2.5rem;
  font-size: 1.5rem;
  width: 25%;
  text-indent: -5px;
}
.download-btn-box {
  width: 400px;
  height: 50px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  box-sizing: border-box;
  padding: 0 20px;
}
.down-icon img {
  height: 50px;
  width: auto;
  display: block;
}
.qrcode-area {
  width: 100%;
  height: 150px;
  border-radius: 10px;
  margin: 0 auto;
  background: rgba(0, 0, 0, 1);
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}
.qrcode-area img {
  display: block;
  height: 130px;
  width: 130px;
  margin: 0 auto;
  margin-top: 10px;
  background: #fff;
}
.qrcode-enter-active,
.qrcode-leave-active {
  transition: all 0.5s;
}
.qrcode-enter, .qrcode-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0px;
  margin-top: 10px;
}
.app-icons {
  display: block;
  width: 80%;
  margin: 0 auto;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0px 0px 41px 0px rgba(129, 129, 129, 0.18);
  transition: all 0.5s;
}
</style>


// WEBPACK FOOTER //
// src/components/pe-home/modules/app-download.vue